import React from "react";
import logoWhite from "../images/paylinq-logo-white.png"; //
import altBanner from "../images/paylinq-banner01.png";

const Authleft = () => {
	return (
		<div className="leftSectionWrap max-md:!tw-hidden">
			<div className="authLogo">
				<img src={logoWhite} alt="App Logo" />
			</div>

			<div className="authBanner">
				<img src={altBanner} alt="Auth Banner" />
			</div>

			<div className="authText">
				<h2>
					Simplify Payments Streamline Reconciliation.
					<br />
					Boost Your Business
				</h2>
				<p>Manage settlements, collections, and reconciliation effortlessly with our all-in-one payment solution.</p>
			</div>
		</div>
	);
};

export default Authleft;
